import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()

// slider
import { tns } from "tiny-slider/src/tiny-slider";

import AOS from 'aos';
AOS.init();

[].forEach.call(document.querySelectorAll('.slider'), function (el) {
    tns({
        container: el,
        slideBy: 'page',
        items : 1,
        autoplay: true,
        controls: true,
        controlsText: ['<span></span>','<span></span>'],
        navPosition: 'bottom',
        autoplayButtonOutput: false,
        autoplayTimeout : 5000,
        responsive: {
            768: {
                items: 1,
            },
        }
    });
});

[].forEach.call(document.querySelectorAll('.sliderTemoignages'), function (el) {
    tns({
        container: el,
        slideBy: 'page',
        items : 1,
        autoplay: true,
        controls: true,
        controlsText: ['<span></span>','<span></span>'],
        navPosition: 'bottom',
        autoplayButtonOutput: false,
        autoplayTimeout : 5000,
        responsive: {
            768: {
                items: 1
            },
            1024: {
                items: 4,
                gutter:30
            },
        }
    });
});